import React from "react";
import T from "prop-types";

import useRezervace from "b2b/api/hooks/useRezervace";
import RezervaceTableContent from "./RezervaceTableContent";

export function RezervaceTable({ datumOd, datumDo, stav, typZdroje }) {
  const loader = useRezervace({
    datumOd,
    datumDo,
    stav,
    typZdroje
  });
  return (
    <RezervaceTableContent
      loading={loader.loading}
      zdroje={loader.data?.zdroje}
      dny={loader.data?.dny}
    />
  );
}
RezervaceTable.propTypes = {
  datumOd: T.instanceOf(Date),
  datumDo: T.instanceOf(Date),
  stav: T.string,
  typZdroje: T.object
};

export default React.memo(RezervaceTable);
